<template>
  <div class="clients">
    <div class="clients--title fs-25 black--text font-weight-medium">
      Clients
    </div>
    <div class="clients-body mt-4" :class="{ 'mt-7': xsOrsm }">
      <div
        class="clients-body__header mb-6 d-sm-flex justify-space-between align-center"
        :class="{ 'text-center': xsOrsm }"
      >
        <div class="clients-body__header__content">
          <div class="clients-body__header__content--title">Want to add a new Client?</div>
          <div class="clients-body__header__content--subtitle">Click on the following button to add a new client</div>
        </div>
        <div class="clients-body__header__button" :class="{ 'mt-4': xsOrsm }">
          <v-btn
            width="255"
            :loading="loading"
            color="button-primary"
            large
            class="white--text"
            @click="addNewClientButtonHandler"
          >
            <span class="font-weight-bold fs-15">Add New Client</span>
          </v-btn>
        </div>
      </div>
      <v-divider class="mb-6"></v-divider>
      <div class="clients-body__search mb-6" :class="searchWidth">
        <DashboardSearch
          text-label="Search Client"
          description="Enter Client details that you want to search"
          @dashboard-search="dashboardSearchActionHandler"
        />
      </div>
      <div class="clients-body__list">
        <v-row class="loader fill-height mt-8 py-6" align="center" justify="center" v-if="loading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
        <div>
          <v-row>
            <v-col v-for="exporter in exporters" :key="exporter.id" cols="12" :xs="12" :sm="12" :md="12" :lg="6">
              <ClientInfoCard :item="exporter" @client-info-card="clientInfoCardActionHandler" />
            </v-col>
          </v-row>
        </div>
      </div>
      <ConfirmDeleteDialog
        v-if="showDeleteConfirmationDialog"
        :loader="isDeletingClient"
        @clicked-yes="deleteExporter"
        @clicked-no="showDeleteConfirmationDialog = false"
        :name="exporter.name"
        :id="exporter.id"
      />
      <AddClientModal
        max-width="800"
        v-if="showAddClientModal"
        :exporter="exporter"
        :loader="isCreatingClient"
        @add-client-modal="addNewExporter"
        @close-client-modal="addClientModalActionHandler"
        @edit-client-modal="updateExporter"
      />
      <AdCodeModal :exporter="exporter" @close-adcode-dialog="adCodeActionHandler" v-if="showAdCodeTable" />
    </div>
  </div>
</template>
<script>
import AddClientModal from "@/modules/DashboardModule/components/AddClientModal";
import DashboardSearch from "@/modules/DashboardModule/components/DashboardSearch";
import ClientInfoCard from "@/modules/DashboardModule/components/ClientInfoCard";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";
import AdCodeModal from "@/modules/DashboardModule/components/AdCode";
import * as AT from "@/modules/DashboardModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
import VueAdBlockDetect from "vue-adblock-detect";
export default {
  name: "Clients",
  components: {
    AddClientModal,
    DashboardSearch,
    ClientInfoCard,
    AdCodeModal,
    ConfirmDeleteDialog
  },
  data() {
    return {
      showAddClientModal: false,
      isDeletingClient: false,
      showDeleteConfirmationDialog: false,
      showAdCodeTable: false,
      isCreatingClient: false,
      loading: false,
      exporters: [],
      originalExporters: [],
      exporter: {
        id: 0,
        name: "",
        iec: "",
        address1: "",
        address2: "",
        branch: "",
        city: "",
        state: "",
        pin: "",
        gstnType: "",
        gstnId: "",
        action: "add"
      }
    };
  },

  mounted() {
    this.getExporters();
  },
  mixins: [commonMethodsMixin, VueAdBlockDetect],
  methods: {
    getEmptyExporter() {
      return {
        id: 0,
        name: "",
        iec: "",
        address1: "",
        address2: "",
        branch: "",
        city: "",
        state: "",
        pin: "",
        bankName: "",
        adCode: "",
        action: "add"
      };
    },
    addNewClientButtonHandler() {
      this.exporter = this.getEmptyExporter();
      this.showAddClientModal = true;
    },
    checkRouteNewClient() {
      if (this.$route.params.newClient === "new") {
        this.showAddClientModal = true;
        return;
      }
    },
    dashboardSearchActionHandler(searchedString) {
      this.exporters = [...this.originalExporters];
      if (searchedString === "") {
        return;
      }
      this.exporters = this.exporters.filter(exporter => {
        return searchedString
          .toLowerCase()
          .split(" ")
          .every(v => exporter.name.toLowerCase().includes(v) || exporter.state.toLowerCase().includes(v));
      });
    },

    clientInfoCardActionHandler(data) {
      if (data && data.action == "edit") {
        // call "EDIT" function here
        const exporter = data.exporter;
        exporter.action = "edit";
        this.exporter = exporter;
        this.showAddClientModal = true;
      } else if (data && data.action == "delete") {
        const exporter = data.exporter;
        exporter.action = "delete";
        this.exporter = exporter;
        this.showDeleteConfirmationDialog = true;
      } else if (data && data.action == "adCode") {
        const exporter = data.exporter;
        this.exporter = exporter;
        this.detectAdBlock().then(res => {
          if (res) {
            const errMessage = "Please disable ad block first !";
            this.throwErrorMessage(errMessage);
            return;
          } else {
            this.showAdCodeTable = true;
          }
        });
      }
    },
    deleteExporter(id) {
      this.isDeletingClient = true;
      this.$store
        .dispatch(AT.DELETE_EXPORTER, id)
        .then(() => {
          this.exporters.splice(
            this.exporters.findIndex(exporter => exporter.id === id),
            1
          );
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isDeletingClient = false;
          this.showDeleteConfirmationDialog = false;
        });
    },
    getExporterFormData(exporter) {
      return {
        name: exporter.name,
        iec: exporter.iec,
        address1: exporter.address1,
        address2: exporter.address2,
        branch: exporter.branch,
        city: exporter.city,
        state: exporter.state,
        pin: exporter.pin,
        gstnType: exporter.gstnType,
        gstId: exporter.gstId,
        bank_name: exporter.bankName,
        ad_code: exporter.adCode
      };
    },
    addNewExporter() {
      this.isCreatingClient = true;
      const formData = this.getExporterFormData(this.exporter);
      this.$store
        .dispatch(AT.ADD_EXPORTER, formData)
        .then(res => {
          if (res && res.data) {
            // this.exporter = this.setExporterObject(res.data);
            this.exporters.push(this.makeExporterFromResponse(res.data));
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.exporter.action = "add";
          this.isCreatingClient = false;
          this.showAddClientModal = false;
        });
    },
    setExporterObject(res) {
      return {
        id: res.id,
        name: res.name,
        iec: res.iec,
        address1: res.address1,
        address2: res.address2,
        branch: res.branch,
        city: res.city,
        state: res.state,
        pin: res.pin,
        action: "adCode",
        ad_code: "",
        bank_name: ""
      };
    },
    makeExporterFromResponse(res) {
      return {
        id: res.exporter.id,
        iec: res.exporter.iec,
        city: res.exporter.city,
        name: res.exporter.name,
        ad_codes: [res.adCode],
        address1: res.exporter.address1,
        address2: res.exporter.address2,
        state: res.exporter.state,
        pin: res.exporter.pin,
        branch: res.exporter.branch,
        gstnType: res.exporter.gstnType,
        gstId: res.exporter.gstId
      };
    },
    updateExporter(exporter) {
      this.isCreatingClient = true;
      const formData = {
        exporterId: exporter.id,
        ...this.getExporterFormData(exporter)
      };
      this.$store
        .dispatch(AT.UPDATE_EXPORTER, formData)
        .then(res => {
          const exporterIndex = this.exporters.findIndex(exporter => exporter.id === res.data.id);
          this.exporters[exporterIndex] = res.data;
          return;
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isCreatingClient = false;
          this.showAddClientModal = false;
        });
    },
    getExporters() {
      this.loading = true;
      this.$store
        .dispatch(AT.GET_EXPORTERS)
        .then(res => {
          if (res) {
            this.exporters = res.data;
            this.originalExporters = res.data;
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.loading = false;
          this.checkRouteNewClient();
        });
    },
    confirmDialogHandler() {
      this.confirmDialog = true;
    },
    addClientModalActionHandler() {
      this.showAddClientModal = false;
    },
    adCodeActionHandler() {
      this.showAdCodeTable = false;
      return;
    }
  }
};
</script>
<style lang="scss">
.clients-body {
  .v-divider {
    border-top-width: 2px;
  }
  &__header {
    &__content {
      &--title {
        font-size: 20px;
        font-weight: 500;
      }
      &--subtitle {
        font-size: 15px;
      }
    }
  }
  &__search {
    margin: auto;
  }
}
</style>
